const initialState = {
    "steps": [
        {
            "name": __("Your subscription"),
            "completed": false,
            "active": true,
            "current": true,
            "valid": true,
            "id": "step_1",
            "childStepIds": [],
        },
        {
            "name": __("Credentials"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_2",
            "childStepIds": [
                "step_3",
                "step_4",
                "step_5",
            ]
        },
        {
            "name": __("Additional information"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_3",
            "parentId": "step_2",
            "childStepIds": []
        },
        {
            "name": __("Password"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_4",
            "parentId": "step_2",
            "childStepIds": []
        },
        {
            "name": __("Company details"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_5",
            "parentId": "step_2",
            "childStepIds": []
        },
        {
            "name": __("Pay"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_6",
            "childStepIds": []
        },
        {
            "name": __("Complete your payment"),
            "completed": false,
            "active": false,
            "current": false,
            "id": "step_7",
            "hidden": true,
            "childStepIds": []
        },
    ],
};

export default initialState;
